import { render } from "./LiveTemplatePreview.vue?vue&type=template&id=64e733e7&scoped=true&ts=true"
import script from "./LiveTemplatePreview.vue?vue&type=script&lang=ts"
export * from "./LiveTemplatePreview.vue?vue&type=script&lang=ts"

import "./LiveTemplatePreview.vue?vue&type=style&index=0&id=64e733e7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e733e7"]])

export default __exports__